<template>
  <section
    class="section-container"
    v-auth-roles="{
      user: userAuth,
      roles: [const_roles.ROLE_STUDENT],
    }"
  >
    <section class="d-block d-sm-none">
      <CDropdownItem @click="tMenu" to="/kardex">Kardex</CDropdownItem>
      <CDropdownItem @click="tMenu" to="/libreta">Libreta</CDropdownItem>
      <CDropdownItem @click="tMenu" to="/programaciones"
        >Programaciones</CDropdownItem
      >
      <CDropdownItem @click="tMenu" to="/pensiones">Pensiones</CDropdownItem>
    </section>

    <CNavItem
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_STUDENT],
      }"
      class="d-none d-sm-block"
      to="/kardex"
      >Kardex</CNavItem
    >
    <CNavItem
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_STUDENT],
      }"
      class="d-none d-sm-block"
      to="/libreta"
      >Libreta</CNavItem
    >
    <CNavItem
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_STUDENT],
      }"
      class="d-none d-sm-block"
      to="/programaciones"
      >Programaciones</CNavItem
    >
    <CNavItem
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_STUDENT],
      }"
      class="d-none d-sm-block"
      to="/pensiones"
      >Pensiones</CNavItem
    >
  </section>
</template>
<script>
import Constants from "@/plugins/constants";
export default {
  name: "StudentMenu",
  props: ["toggleMenu"],
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  data() {
    return {
      const_roles: Constants.roles,
    };
  },
  methods: {
    tMenu() {
      this.toggleMenu();
    },
  },
};
</script>
<style scoped>
.dropdown-item {
  color: #fff;
}
.section-container {
  display: inherit;
}
</style>